const API_VERSION = "12";
const SECURE_API_ENDPOINT = process.env.REACT_APP_SECURE_API_URL;
const EMAIL_REGEX = new RegExp(
  "^([-.\\w]*[0-9a-zA-Z]([-.\\w]*[0-9a-zA-Z+])*@([0-9a-zA-Z][-\\w]*[0-9a-zA-Z]\\.)+[a-zA-Z]{2,9})$"
);

export { API_VERSION, EMAIL_REGEX, SECURE_API_ENDPOINT };
